
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 6853 973","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#01d01a"}},[_c('circle',{attrs:{"cx":"486.488","cy":"486.488","r":"486.488"}}),_c('circle',{attrs:{"cx":"1662.45","cy":"486.488","r":"486.488"}}),_c('circle',{attrs:{"cx":"2838.41","cy":"486.488","r":"486.488"}}),_c('circle',{attrs:{"cx":"4014.38","cy":"486.488","r":"486.488"}}),_c('circle',{attrs:{"cx":"5190.34","cy":"486.488","r":"486.488"}}),_c('circle',{attrs:{"cx":"6366.3","cy":"486.488","r":"486.488"}})]),_c('path',{attrs:{"d":"M6356.55 412.238c36.5 0 68 7.25 94.5 21.75s46.75 34.5 60.75 60 21 54.5 21 87c0 35-8.125 65.5-24.375 91.5s-38.5 46.125-66.75 60.375-60.125 21.375-95.625 21.375c-27 0-53.375-3.5-79.125-10.5s-48.125-16.75-67.125-29.25l17.25-66c21.5 12 42 21.125 61.5 27.375s40.75 9.375 63.75 9.375c33.5 0 60.625-9.5 81.375-28.5s31.125-44.25 31.125-75.75c0-35-11-62.125-33-81.375s-51.5-28.875-88.5-28.875c-31.5 0-66.75 5-105.75 15l32.25-267h247.5l-3 67.5h-186l-15.75 129.75c19-2.5 37-3.75 54-3.75z","fill":"#fff","fill-rule":"nonzero"}})])
          )
        }
      }
    